import type { AnalyticsEvent } from './Analytics';

type SiteImprovePageView = [
  'trackdynamic',
  {
    url: string;
    ref?: string;
    title: string;
  },
];

type SiteImproveEvent = ['event', string, string, string | undefined];

type SiteImproveToggleTrackingAction = ['notrack'] | ['notrack', false];

export type SiteImproveAction =
  | SiteImprovePageView
  | SiteImproveEvent
  | SiteImproveToggleTrackingAction;

const siteImproveCache: Array<SiteImproveAction> = [];

export const trackSiteImproveEvent = (event: AnalyticsEvent) => {
  const sIevent: SiteImproveEvent = [
    'event',
    event.category,
    event.action,
    event.label,
  ];
  if (!window._sz) {
    siteImproveCache.push(sIevent);
  } else {
    window._sz.push(sIevent);
  }
};

export const trackSiteImprovePageView = (page: string, referrer?: string) => {
  const pageUrl = new URL(page);
  const referrerUrl = referrer ? new URL(referrer) : undefined;

  const pageview: SiteImprovePageView = [
    'trackdynamic',
    {
      url:
        pageUrl.origin +
        window.redactSiteImproveUrl(pageUrl.pathname) +
        pageUrl.search,
      ref: referrerUrl
        ? referrerUrl.origin +
          window.redactSiteImproveUrl(referrerUrl.pathname) +
          referrerUrl.search
        : '',
      title: document.title,
    },
  ];
  if (!window._sz) {
    siteImproveCache.push(pageview);
  } else {
    window._sz.push(pageview);
  }
};

export const enableSiteImproveTracking = () => {
  const enableEvent: SiteImproveToggleTrackingAction = ['notrack', false];
  if (document.getElementById('stag')) {
    if (!window._sz) {
      siteImproveCache.push(enableEvent);
    } else {
      window._sz.push(enableEvent);
    }
    return;
  }

  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.addEventListener('load', () => {
    setTimeout(() => {
      siteImproveCache.forEach((action) => {
        window._sz?.push(action);
      });
    }, 500);
  });
  script.src = 'https://siteimproveanalytics.com/js/siteanalyze_6015663.js';
  script.async = true;
  script.type = 'text/javascript';
  script.id = 'stag';
  head.appendChild(script);
};

export const disableSiteImproveTracking = () => {
  const disableEvent: SiteImproveToggleTrackingAction = ['notrack', false];
  if (document.getElementById('stag')) {
    if (!window._sz) {
      siteImproveCache.push(disableEvent);
    } else {
      window._sz.push(disableEvent);
    }
    return;
  }
};
